import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfig } from '~shared/constants/api.config';
import { ReturnRequestPayload } from '../models/return-request-payload.model';
import {ReturnReason} from '~app/modules/account/modules/orders-history/models/return-reason.model';
import { AccountInfoService } from '~app/core/modules/identity/services/account-info.service';
import { MarketDetectionUtil } from '~shared/utils/market-detection.util';
import { IAccountInformation } from '~shared/models';
import { ActiveFeaturesConfigcatService } from '~shared/modules/active-features/services';

@Injectable({
  providedIn: 'root',
})

export class OrderReturnsService {
  private readonly buyerGateWayUrl = ApiConfig.SVC_BUYER_GATEWAY_URL_API_ENDPOINT();
  private accountInfo: IAccountInformation;

  constructor(
    private httpClient: HttpClient,
    private accountInfoService: AccountInfoService,
    private readonly featureFlagService: ActiveFeaturesConfigcatService,
  ) {
    this.accountInfoService.getAccountInfo().subscribe((accountInfo) => {
      this.accountInfo = accountInfo;
    });
  }

  getReturnReasons(orderLineId? : string): Observable<ReturnReason[]> {
    let url = `${this.buyerGateWayUrl}/api/account/proxy/aom/v2/dictionary/return-reasons`;
    if (orderLineId) {
      url += `?orderLineId=${orderLineId}`
    }

    return this.httpClient.get<ReturnReason[]>(url, this.getHttpOptions());
  }

  returnProduct(payload: ReturnRequestPayload) {
    const url = `${this.buyerGateWayUrl}/api/account/proxy/aom/v2/orders/${payload.orderId}/return`;
    const body = {
      orderLines: [{ orderLineId: payload.orderLineId, quantity: payload.quantity }],
      returnReason: payload.returnReason,
    };

    return this.httpClient.post<{}>(url, body, this.getHttpOptions());
  }

  returnOrder(orderId: string, orderLineIds: string[], returnReason: string): Observable<{}> {
    const url = `${this.buyerGateWayUrl}/api/account/proxy/aom/v2/orders/${orderId}/return`;
    const body = {
      orderLines: orderLineIds.map(orderLineId => {
        return {orderLineId};
      }),
      returnReason,
    };

    return this.httpClient.post<{}>(url, body, this.getHttpOptions());
  }

  cancelReturnProduct(orderId: string, orderLineId: string): Observable<{}> {
    return this.cancelReturn(orderId, [orderLineId]);
  }

  cancelReturnOrder(orderId: string, orderLineIds: string[]): Observable<{}> {
    return this.cancelReturn(orderId, orderLineIds);
  }

  private cancelReturn(orderId: string, orderLineIds: string[]): Observable<{}> {
    const url = `${this.buyerGateWayUrl}/api/account/proxy/aom/v2/orders/${orderId}/cancel-return`;

    return this.httpClient.post<{}>(url, { orderLineIds }, this.getHttpOptions());
  }

  private getHttpOptions() {
    return {
      headers: new HttpHeaders({
        'Country-Code': MarketDetectionUtil.getCountryCode(),
        'X-Active-Context': this.accountInfo.activeContext,
      }),
    };
  }
}
